import { useContext } from "react";

import { GlobalContext } from "@/contexts/GlobalContext";

import useFetch from "./useFetchData";

import { CartelInfo, VehicleIndex } from "@/types/Vehicles.types";

const useFetchVehicle = () => {
    const { globalState: { apiUrl }, dispatchGlobal } = useContext(GlobalContext);
    const { useFetchData } = useFetch();

    const fetchVehicle = async (ktype: string) => {
		const url: string = apiUrl + `/vehicles/details?kcode=${ktype}`;

		try {
			const result = await useFetchData<{ vehicle: VehicleIndex; vrm: CartelInfo | null; }>(url);

			if (!result.success) {
                return false;
			}

            if (result.data.vehicle) {
                dispatchGlobal({ type: "SET_VHINFO", vhInfo: result.data.vehicle });

                localStorage.setItem("__vhi", JSON.stringify(result.data.vehicle));
                localStorage.setItem("__ktype", result.data.vehicle.KCODE_B);
                localStorage.setItem("_lvsd", new Date().getTime().toString());
                localStorage.removeItem("_vrmi");
            }

            if (result.data.vrm) {
                dispatchGlobal({ type: "SET_VRMINFO", vrmInfo: result.data.vrm });

                localStorage.setItem("__vrmi", JSON.stringify(result.data.vrm));
                localStorage.setItem("_lvsd", new Date().getTime().toString());
            }
		} catch (error) {
			console.error(error);
		}
	};

    return {
        fetchVehicle
    };

};

export default useFetchVehicle;
